import * as React from 'react';
import { AnalyticPropertyInfo } from '../../../../api/Property';
import { Bar } from 'react-chartjs-2';
import '../../../../styles/AdminDashboardPage.css';
import { convert12HrsTimeFormat } from '../helperFunctions/timeFunctions';

interface ToursTimeProps {
    dashboardData?: AnalyticPropertyInfo;
  }

  const countOnTopPlugin: Chart.PluginServiceGlobalRegistration & Chart.PluginServiceRegistrationOptions = {
    afterDatasetsDraw: function(chart, easing) {
        if(chart){
            const ctx = chart.ctx;

            // Check if ctx is available
            if (!ctx) {
                return;
            }

            // Check if chart data and datasets exist
            if (chart.data && chart.data.datasets) {
                console.log(chart.data.datasets)
                chart.data.datasets.forEach(function(dataset, datasetIndex) {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    if (!meta || meta.hidden) {
                        return;
                    }

                    // Check if dataset data exists
                    if (!dataset.data) {
                        return;
                    }

                    meta.data.forEach(function(bar, index) {
                        // Check if bar exists
                        if (!bar) {
                            return;
                        }
                        console.log(dataset.data)

                        if(dataset.data && dataset.data[index]!=null){
                        // Get the data value and convert it to string for display
                            const data = dataset.data[index]!.toString();

                            if(data){

                            // Draw the count on top of the bar
                                ctx.fillStyle = 'black';
                                ctx.font = 'bold 12px Arial';
                                ctx.textAlign = 'center';
                                // Accessing chartArea to get the width and calculate the position
                                const x = bar._model.x;
                                const y = bar._model.y - 5;
                                ctx.fillText(data, x, y);

                            }
                        }
                    });
                });
            }

        }
    }
};

export const ToursTimeCard = ({ dashboardData }: ToursTimeProps) => {

  const sortDataByHour = (data: { hour: number, count: number, percentage: number }[]) => {
        return data.sort((a, b) => a.hour - b.hour);
    };

  const sortedDashboardTourTimes = dashboardData ? sortDataByHour(dashboardData.dashboardTourTimes) : [];
    
  
  return  <div className='bordered-card-layout'>
  <p className='dashboard-heading'>Tour Times</p>
  <Bar
      data={{
              labels: sortedDashboardTourTimes.map(data => convert12HrsTimeFormat(data.hour)),
              datasets: [
                  {
                      data: sortedDashboardTourTimes.map(data => data.percentage),
                      backgroundColor: sortedDashboardTourTimes.map(data => {
                        return '#27bbf9';
                    }) 
                      
                  }
              ]
          }}
          options={{
              scales: {
                  xAxes: [
                      {
                          gridLines: {
                              display: false
                          }
                      }
                  ],
                  yAxes: [
                  {
                      ticks: {
                          callback: function(value) {
                              return `${value}%`; // Format y-axis ticks as percentages
                          }
                      }
                  }
              ]
              },
              legend: {
                  display: false
              },
              tooltips: {
              callbacks: {
                  label: function (tooltipItem, data) {
                      if (!data || !data.datasets || !data.datasets.length || !data.labels) return ''; // Check if data, data.datasets, or data.labels is undefined or empty
                      const datasetIndex: number = tooltipItem.datasetIndex !== undefined ? tooltipItem.datasetIndex : -1; // Ensure datasetIndex is typed as number and not undefined
                      const index: number = tooltipItem.index !== undefined ? tooltipItem.index : -1; // Ensure index is typed as number and not undefined
                      const dataset = data.datasets[datasetIndex];
                      if (!dataset || !dataset.data || !dataset.data.length || index === -1) return ''; // Check if dataset or dataset.data is undefined or empty, or index is -1
                      const hour = data.labels[index];
                      const item = sortedDashboardTourTimes.find(item => convert12HrsTimeFormat(item.hour) === hour) || { count: 0, percentage: 0 };
                      const count = item ? item.count: 0;
                      return count.toLocaleString('en-US');
                  }
              },
              enabled: true
          },
          plugins: [
              countOnTopPlugin
          ],
          responsive: false,
          layout: {
                  padding: {
                      top: 20,
                      right: 0,
                      bottom: 0,
                      left: 0
                  }
              },
              maintainAspectRatio: false,
              animation: {
                  duration: 0
              }
          }}
      />
  </div>
}


// WEBPACK FOOTER //
// ./src/components/pages/admin/analyticsDashboardWidgets/toursTimeCard.tsx